var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_994_6825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38281 13.1301C5.51492 13.231 5.74103 13.4496 6.01135 13.6378C6.30123 13.7651 6.56573 13.9675 6.83123 14.1707C6.89785 14.2217 6.96348 14.2719 7.05919 14.3904",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0294 2.18337C13.2463 1.89754 13.6847 1.40061 13.8028 1.40784C14.6884 1.46203 15.734 2.81007 15.6892 2.90991C15.5645 3.11512 15.4324 3.34389 15.262 3.55501C15.19 3.63639 15.1475 3.66547 15.044 3.77407",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0597 2.98181C11.1289 2.89059 11.242 2.68768 11.5032 2.3292C11.592 2.20731 11.6989 2.16638 11.7926 2.12412C11.9925 2.03398 12.2341 2.22121 12.4448 2.29835C12.711 2.39583 13.0054 2.62058 13.9513 3.32748C14.3766 3.64532 14.7219 4.00487 15.3117 4.50416C15.451 4.62203 15.4027 4.76927 15.3826 4.91821C15.1268 5.32386 15.0766 5.47165 14.9925 5.62339C14.9249 5.72636 14.8067 5.88206 14.685 6.04247",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49546 11.2127C5.58355 11.2591 5.89016 11.4503 6.47657 11.8438C6.85849 12.1231 7.5721 12.6646 7.9641 12.9518C8.3561 13.2391 8.40487 13.2556 8.57307 13.3622",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6068 5.98277C14.6265 5.95682 14.6402 5.88483 14.5938 5.75664C14.5209 5.55572 14.3039 5.48464 13.8252 5.09042C13.3845 4.72753 12.5063 4.07907 12.034 3.73098C11.5131 3.36633 11.359 3.2705 11.1774 3.14288C11.0995 3.09403 11.0507 3.07747 10.9707 3.09972",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89771 13.6701C9.09544 13.4911 9.32039 13.2486 10.1649 12.15C10.3434 11.9176 10.352 11.8629 10.7199 11.3642C11.0878 10.8655 11.8065 9.91837 12.1899 9.39957C12.8363 8.52495 13.2269 7.91085 13.4553 7.56866C13.6218 7.28111 13.7583 7.07429 13.8917 6.85767C14.0085 6.68983 14.2251 6.40438 14.4482 6.11029",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7613 3.3749C10.6432 3.53059 10.1196 4.22061 9.39229 5.16559C9.13186 5.50398 9.07538 5.54282 8.73336 5.97967C8.39134 6.41653 7.76125 7.24691 7.42837 7.69906C6.98776 8.29756 6.87958 8.54436 6.70566 8.81479C6.55701 9.04593 6.4212 9.31174 6.28204 9.53636C6.09002 9.84631 5.96282 10.0791 5.81366 10.3169C5.76346 10.4235 5.72984 10.5225 5.68505 10.6223C5.65683 10.6734 5.61745 10.7253 5.55652 10.8873",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46131 11.0938C5.45842 11.1691 5.43923 11.334 5.41871 11.6122C5.41433 11.6716 5.40601 11.6917 5.38737 12.091C5.36873 12.4904 5.33887 13.2681 5.31988 13.6789C5.29361 14.2474 5.25679 14.5636 5.24166 14.7014C5.23627 14.7505 5.21384 15.0021 5.22282 15.3545C5.22593 15.4763 5.28565 15.4766 5.32511 15.4712C5.39848 15.4613 5.45059 15.4278 5.58565 15.3508C5.90856 15.1667 6.21264 15.0156 6.361 14.9524C6.54265 14.8749 6.7278 14.787 7.12767 14.562C7.3807 14.4197 7.84093 14.1721 8.09402 14.0377C8.45291 13.8523 8.56587 13.7875 8.66784 13.7399C8.73719 13.7048 8.84227 13.6474 8.95053 13.5882",
    stroke: "black",
    strokeWidth: 0.75002,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59716 17.0707C2.62566 17.0564 7.06556 17.2261 9.19058 17.0707C11.3364 16.9138 11.1476 17.0275 15.5078 17.0275",
    stroke: "black",
    strokeWidth: 0.900024,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_994_6825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0005,
    height: 18.0005,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0.499878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f359c5073eec0f940aabd28a578ef295.svg";
export { ForwardRef as ReactComponent };